import divisionsData from './bd_divisions.json'
import districtsData from './bd_districts.json'
import upazilasData from './bd_upazilas.json'

export const BD_DIVISIONS = divisionsData.map(d => ({
  id: d.id,
  name: d.name === 'Chattagram' ? 'Chattogram' : d.name,
})).sort((a, b) => a.name.localeCompare(b.name))

export const BD_DISTRICTS = districtsData.map(d => ({
  id: d.id,
  division_id: d.division_id,
  name: d.name,
}))

export const BD_UPAZILAS = upazilasData.map(u => ({
  id: u.id,
  district_id: u.district_id,
  name: u.name,
}))

export function getDistrictsByDivision(divisionId) {
  return BD_DISTRICTS
    .filter(d => d.division_id === divisionId)
    .sort((a, b) => a.name.localeCompare(b.name))
}

export function getUpazilasByDistrict(districtId) {
  return BD_UPAZILAS
    .filter(u => u.district_id === districtId)
    .sort((a, b) => a.name.localeCompare(b.name))
}

// Get unions by single upazila
let unionsCache = null

async function loadUnions() {
  if (!unionsCache) {
    const data = await import('./bd_unions.json')
    unionsCache = data.default.map(u => ({
      id: u.id,
      upazila_id: u.upazilla_id,
      name: u.name,
    }))
  }
  return unionsCache
}

export async function getUnionsByUpazila(upazilaId) {
  const all = await loadUnions()
  return all
    .filter(u => u.upazila_id === upazilaId)
    .sort((a, b) => a.name.localeCompare(b.name))
}

// Get ALL unions for an entire district — used when upazilla is N/A
// Combines unions from all upazilas in the district
export async function getAllUnionsByDistrict(districtId) {
  const upazilas = getUpazilasByDistrict(districtId)
  const upazilaIds = new Set(upazilas.map(u => u.id))
  const all = await loadUnions()
  const seen = new Set()
  return all
    .filter(u => {
      if (!upazilaIds.has(u.upazila_id)) return false
      if (seen.has(u.name.toLowerCase())) return false
      seen.add(u.name.toLowerCase())
      return true
    })
    .sort((a, b) => a.name.localeCompare(b.name))
}